import { useState } from 'react';
import { Eye, Code } from 'lucide-react';

export function SimpleHtmlEditor({ value, onChange, label, placeholder, rows = 20 }) {
  const [view, setView] = useState('split'); // 'split' | 'editor' | 'preview'

  return (
    <div>
      {label && (
        <div className="flex items-center justify-between mb-2">
          <label className="text-sm font-medium text-slate-700">{label}</label>

          <div className="flex gap-1 bg-slate-100 rounded-lg p-0.5">
            <button
              type="button"
              onClick={() => setView('editor')}
              className={`px-2 py-1 text-xs rounded ${view === 'editor' ? 'bg-white shadow-sm font-medium' : 'text-slate-500'}`}
            >
              <Code size={12} className="inline mr-1" /> HTML
            </button>
            <button
              type="button"
              onClick={() => setView('split')}
              className={`px-2 py-1 text-xs rounded ${view === 'split' ? 'bg-white shadow-sm font-medium' : 'text-slate-500'}`}
            >
              Bölünmüş
            </button>
            <button
              type="button"
              onClick={() => setView('preview')}
              className={`px-2 py-1 text-xs rounded ${view === 'preview' ? 'bg-white shadow-sm font-medium' : 'text-slate-500'}`}
            >
              <Eye size={12} className="inline mr-1" /> Önizleme
            </button>
          </div>
        </div>
      )}

      <div className={`grid gap-3 ${view === 'split' ? 'md:grid-cols-2' : 'grid-cols-1'}`}>
        {(view === 'split' || view === 'editor') && (
          <textarea
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder || '<h1>Başlık</h1>\n<p>İçerik metni...</p>'}
            rows={rows}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm font-mono focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
          />
        )}

        {(view === 'split' || view === 'preview') && (
          <div
            className="border border-slate-200 rounded-lg p-4 bg-slate-50 min-h-[300px] overflow-y-auto"
            style={{ maxHeight: `${rows * 28}px` }}
          >
            {value ? (
              <div
                className="prose prose-sm max-w-none text-slate-700"
                dangerouslySetInnerHTML={{ __html: value }}
              />
            ) : (
              <p className="text-slate-400 text-sm italic">Önizleme burada görünecek...</p>
            )}
          </div>
        )}
      </div>

      <p className="text-xs text-slate-500 mt-2">
        HTML kullanın: &lt;h1&gt;, &lt;h2&gt;, &lt;p&gt;, &lt;strong&gt;, &lt;em&gt;, &lt;ul&gt;, &lt;li&gt;, &lt;a href=""&gt;
      </p>
    </div>
  );
}
